import { render, staticRenderFns } from "./BaseStatusChip.vue?vue&type=template&id=27063934&scoped=true"
import script from "./BaseStatusChip.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseStatusChip.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BaseStatusChip.vue?vue&type=style&index=0&id=27063934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27063934",
  null
  
)

export default component.exports